import { atom } from 'jotai';

import { CommonApi } from '@/api';
import { Omega } from '@/lib';
import { LocalStorageDic } from '@/config';

const { getUserAuth, getFilterList } = CommonApi;

export const siderOpenAtom = atom(false);
export const siderCollapsedAtom = atom(false); // 侧边栏折叠状态
export const menuAtom = atom([]);
export const loginInfoAtom = atom({});
export const errnoAtom: any = atom(-1);
export const filterListAtom = atom({
  bill_status_list: null,
  display_name_list: null,
  order_status_list: null,
  product_list: null,
  reason_list: null,
  station_list: null
});

export const setUserAuth = atom(null, async (get, set) => {
  let authData: any = {};
  let errno: any = -1;

  try {
    const { data } = await getUserAuth(); // 将参数传递给queryMockList函数

    authData = (data as any)?.data;
    errno = (data as any)?.errno;
  } catch ({ data }: any) {
    // 处理异常情况
    authData = (data as any)?.data;
    errno = (data as any)?.errno;
  } finally {
    set(menuAtom, (authData as any)?.ops_auth_menu || []);
    set(loginInfoAtom, (authData as any)?.login_info || {});
    set(errnoAtom, errno);
    sessionStorage.setItem('userAuth', JSON.stringify(authData || {}));

    if (!localStorage.getItem(LocalStorageDic.isLogin)) {
      const loginInfo = (authData as any)?.login_info;

      // 上报登录埋点
      Omega.trackEvent('ibt_gs_merchant_login_user_info_ck', '登录成功', {
        login_email: loginInfo?.email,
        user_id: loginInfo?.user_id,
        user_name: loginInfo?.email,
        login_time: new Date().getTime()
      });
      localStorage.setItem(LocalStorageDic.isLogin, 'true');
    }
  }
});

export const setFilterList = atom(null, async (get, set) => {
  try {
    const response: any = await getFilterList();

    set(
      filterListAtom,
      response.data || {
        bill_status_list: null,
        display_name_list: null,
        order_status_list: null,
        product_list: null,
        reason_list: null,
        station_list: null
      }
    );
  } catch (error) {
    console.error('filterList获取失败：', error);
    set(filterListAtom, {
      bill_status_list: null,
      display_name_list: null,
      order_status_list: null,
      product_list: null,
      reason_list: null,
      station_list: null
    });
  }
});

export const setSiderOpen = atom(null, (get, set, payload: boolean) => set(siderOpenAtom, payload));
